import { useConfirm } from './useConfirm'
import { useUpdateDemoSchoolClass } from './mutations/useUpdateDemoSchoolClass'

const useConfirmRemoveDemoSchoolClass = (demoSchoolClass) => {
  const { confirm } = useConfirm()
  const { post } = useUpdateDemoSchoolClass()

  const confirmRemoveDemoSchoolClass = async (onSuccess) => {
    const confirmed = await confirm({
      title: demoSchoolClass.name,
      text: 'Är du säker på att du vill dölja denna klass i ditt lärarrum? Böcker som du har delat med klassen kommer att försvinna för eleverna.',
      confirmText: 'Ja, dölj klass',
      cancelText: 'Avbryt',
    })

    if (!confirmed) return

    const res = await post({
      connected: false,
      id: demoSchoolClass.id,
    },
      'Klassen doldes'
    )

    if (res.success && typeof onSuccess === 'function') {
      onSuccess()
    }
  }

  return { confirmRemoveDemoSchoolClass }
}

export { useConfirmRemoveDemoSchoolClass }
